import { render } from "./ClientTicket.vue?vue&type=template&id=06ce1d86&scoped=true"
import script from "./ClientTicket.vue?vue&type=script&lang=js"
export * from "./ClientTicket.vue?vue&type=script&lang=js"

import "./ClientTicket.vue?vue&type=style&index=0&id=06ce1d86&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ce1d86"]])

export default __exports__